/* Поиск: оверлей по лупе в шапке + живые подсказки.
   Подсказки — предиктивный эндпоинт Shopify с section_id=predictive-search:
   сервер рендерит секцию с ценами/локализацией, мы вставляем готовый HTML. */
(function () {
  if (window.__tmSearch) return;
  window.__tmSearch = true;

  var ready = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  ready(function () {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;
    var panel = overlay.querySelector('[data-search-panel]');
    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var idle = overlay.querySelector('[data-search-idle]');
    var lastFocus = null;
    var controller = null;
    var timer = null;

    var open = function () {
      lastFocus = document.activeElement;
      overlay.classList.add('is-open');
      document.documentElement.classList.add('srch-lock');
      setTimeout(function () { input.focus(); }, 60);
      document.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    };
    var close = function () {
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('srch-lock');
      document.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-search-open]');
      if (opener) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-search-close]')) { close(); return; }
      if (overlay.classList.contains('is-open') && e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      /* примитивная ловушка фокуса внутри панели */
      if (e.key === 'Tab') {
        var focusables = panel.querySelectorAll('a[href], button, input');
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    var showIdle = function () {
      if (idle) idle.hidden = false;
      results.hidden = true;
      results.innerHTML = '';
    };

    var fetchSuggestions = function (q) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = overlay.dataset.predictiveUrl +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6&resources[limit_scope]=each' +
        '&section_id=predictive-search';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.querySelector('[data-psr]');
          results.innerHTML = inner ? inner.innerHTML : '';
          results.hidden = false;
          if (idle) idle.hidden = true;
          var viewAll = results.querySelector('[data-psr-all]');
          if (viewAll) viewAll.href = overlay.dataset.searchUrl + '?q=' + encodeURIComponent(q);
        })
        .catch(function (err) { if (err.name !== 'AbortError') showIdle(); });
    };

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { showIdle(); return; }
      timer = setTimeout(function () { fetchSuggestions(q); }, 220);
    });
  });
})();
